/**
 * 用户某次答题的记录
 */

import React, {useState} from 'react';
import { useRequest, useBrowserTitle } from 'hook/index';
import { Item, ItemView } from './Item';
import styles from './Record.module.scss';
import qs from 'query-string';
import {BlockEmpty, BlockLoading} from 'component/BlockLoading/BlockLoading';
import { ExerciseRecordList } from 'component/ExerciseRecordList/ExerciseRecordList';

interface BackendData {
    list: Item[];
    skill: {
        // 技能中文名
        appNameCh: string;
    };
}

export default function Record() {
    const [recordId] = useState<string>(function() {
        const searchConf = qs.parse(window.location.search.substring(1));
        return (searchConf.sessionid || '') as string;
    });
    /**
     * 本轮最后一题的时刻，由家长通知卡片的 url 带来。
     *
     * ⚠️ 必须透传给接口：`sessionid` 的实际形状是 `平台_技能_用户id`，
     * 同一个孩子同一个技能**永久复用**（实测一条跨 8 天 56 行）。不带 runTs，
     * 这一页会列出该技能的全部历史 —— 而家长是从"本次练习报告"点进来的，
     * 预期看到的是刚才那几道。服务端缺失时退回返回全部，所以老链接不会变空白。
     */
    const [runTs] = useState<string>(function() {
        const searchConf = qs.parse(window.location.search.substring(1));
        const v = (searchConf.runTs || '') as string;
        // 只认纯数字，别把 query 里的任意内容拼进 url
        return /^\d+$/.test(v) ? v : '';
    });
    const {
        loading,
        data,
    } = useRequest<BackendData>({
        url: `/wx/exercise/record?recordId=${encodeURIComponent(recordId)}`
            + (runTs ? `&runTs=${encodeURIComponent(runTs)}` : ''),
        method: 'GET',
        defaultData: { list: [], skill: { appNameCh: ''} },
        defaultIsLoading: true,
    });
    return (
        <ExerciseRecordList loading={loading} data={data} pageTitleSuffix="答题记录" />
    );
    // let pageTitle = '答题记录';
    // if (data.skill && data.skill.appNameCh) {
    //     pageTitle = `${data.skill.appNameCh}-答题记录`;
    // }
    // useBrowserTitle(pageTitle);
    // let content = null;
    // if (!loading) {
    //     if (data.list.length < 1) {
    //         content = (<BlockEmpty/>);
    //     } else {
    //         content = (
    //             <div>
    //                 {
    //                     data.list.map(function(obj: Item, index: number){
    //                         return (<ItemView key={index} item={obj} />);
    //                     })
    //                 }
    //             </div>
    //         );
    //     }
    // }
    // return (
    //     <div>
    //         { loading && <BlockLoading />}
    //         { content }
    //     </div>
    // );
}
